import { colors } from '../../styles/theme/theme'

export interface HeaderColorScheme {
  appBarBackground: string
  appBarBorderBottom?: string
  isLight: boolean
  scrollButtonColor: string
  tabHoverBackground: string
  tabIndicator: string
  tabSelectedBackground: string
  tabSelectedText: string
  tabText: string
  tabTextHover: string
}

export const headerLogoBoxBackground = colors.secondary!.dark!

const lightHeaderTabText = '#2D3540'
const lightHeaderTabTextHover = '#1F2933'
const lightHeaderTabTextSelected = '#141A20'

const darkHeaderTabText = 'rgba(255, 255, 255, 0.7)'
const darkHeaderTabTextHover = 'rgba(255, 255, 255, 0.9)'
const darkHeaderTabTextSelected = '#ffffff'

export const LIGHT_HEADER_COLOR_SCHEME: HeaderColorScheme = {
  appBarBackground: colors.header!,
  appBarBorderBottom: colors.divider!,
  isLight: true,
  tabText: lightHeaderTabText,
  tabTextHover: lightHeaderTabTextHover,
  tabSelectedText: lightHeaderTabTextSelected,
  tabHoverBackground: 'rgba(45, 53, 64, 0.08)',
  tabSelectedBackground: 'rgba(45, 53, 64, 0.12)',
  tabIndicator: colors.secondary!.main!,
  scrollButtonColor: lightHeaderTabText,
}

export const DARK_HEADER_COLOR_SCHEME: HeaderColorScheme = {
  appBarBackground: '#2D3540',
  appBarBorderBottom: 'rgba(255, 255, 255, 0.12)',
  isLight: false,
  tabText: darkHeaderTabText,
  tabTextHover: darkHeaderTabTextHover,
  tabSelectedText: darkHeaderTabTextSelected,
  tabHoverBackground: 'rgba(255, 255, 255, 0.08)',
  tabSelectedBackground: 'rgba(255, 255, 255, 0.12)',
  tabIndicator: colors.secondary!.main!,
  scrollButtonColor: darkHeaderTabText,
}

/** @deprecated Use LIGHT_HEADER_COLOR_SCHEME */
export const HEADER_COLOR_SCHEME = LIGHT_HEADER_COLOR_SCHEME
